import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import NavigationLink from './NavigationLink';
import RentalButton from './RentalButton';
import { navigationLinks } from './navigationConfig';

export default function MobileMenu({ isOpen, onClose, scrollProgress }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40"
          />

          {/* Menu Panel */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed top-24 inset-x-0 max-h-[calc(100vh-6rem)] overflow-y-auto z-50 border-t border-red-100"
            style={{
              backgroundColor: `rgba(255, 255, 255, ${0.98 + scrollProgress * 0.02})`,
              backdropFilter: `blur(${8 + scrollProgress * 4}px)`,
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
          >
            <div className="max-w-7xl mx-auto px-4 py-6">
              <nav className="flex flex-col space-y-3">
                {navigationLinks.map(link => (
                  <motion.div
                    key={link.to}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    onClick={onClose}
                    className="w-full"
                  >
                    <NavigationLink 
                      to={link.to}
                      scrollProgress={scrollProgress}
                      className="w-full block px-4 py-3 rounded-lg hover:bg-red-50 transition-colors"
                    >
                      {link.label}
                    </NavigationLink>
                  </motion.div>
                ))}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  className="pt-2"
                >
                  <div onClick={onClose} className="px-4">
                    <RentalButton fullWidth scrollProgress={scrollProgress} />
                  </div>
                </motion.div>
              </nav>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}